
// @ts-nocheck


export const localeCodes =  [
  "en",
  "cs"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_3584857e",
      load: () => import("#nuxt-i18n/3584857e" /* webpackChunkName: "locale_en_46js_3584857e" */),
      cache: false
    }
  ],
  cs: [
    {
      key: "locale_cs_46js_cd526d90",
      load: () => import("#nuxt-i18n/cd526d90" /* webpackChunkName: "locale_cs_46js_cd526d90" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: true
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "EN",
      files: [
        {
          path: "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/i18n/locales/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "cs",
      language: "cs-CZ",
      name: "CZ",
      files: [
        {
          path: "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/i18n/locales/cs.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "cs",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://avu.cz",
  customRoutes: "config",
  pages: {
    index: {
      cs: "/",
      en: "/"
    },
    search: {
      cs: "/hledej",
      en: "/search"
    },
    alumni: {
      cs: "/alumni",
      en: "/alumni"
    },
    "akademie/index": {
      cs: "/akademie",
      en: "/academy"
    },
    "akademie/[id]/[item]": {
      cs: "/akademie/[id]/[item]",
      en: "/academy/[id]/[item]"
    },
    "article/[slug]": {
      cs: "/stranka/[slug]",
      en: "/article/[slug]"
    },
    "department/[slug]": {
      cs: "/oddeleni/[slug]",
      en: "/department/[slug]"
    },
    "employee/[slug]": {
      cs: "/zamestnanec/[slug]",
      en: "/employee/[slug]"
    },
    "notice/[slug]": {
      cs: "/aktualita/[slug]",
      en: "/notice/[slug]"
    },
    "program/index": {
      cs: "/program",
      en: "/program"
    },
    "program/[id]/[item]": {
      cs: "/program/[id]/[item]",
      en: "/program/[id]/[item]"
    },
    "program/[category]": {
      cs: "/program/[category]",
      en: "/program/[category]"
    },
    "publication/[slug]": {
      cs: "/publikace/[slug]",
      en: "/publication/[slug]"
    },
    "student/[slug]": {
      cs: "/student/[slug]",
      en: "/student/[slug]"
    },
    "studium/index": {
      cs: "/studium",
      en: "/study"
    },
    "studium/[id]/[item]": {
      cs: "/studium/[id]/[item]",
      en: "/study/[id]/[item]"
    },
    "other/people": {
      cs: "/ostatni/lide",
      en: "/other/people"
    },
    "other/publication": {
      cs: "/ostatni/publikace",
      en: "/other/publication"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "EN",
    files: [
      {
        path: "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/i18n/locales/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "cs",
    language: "cs-CZ",
    name: "CZ",
    files: [
      {
        path: "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/i18n/locales/cs.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/